angular.module('edxResources')
  .value('edxResourcesContent', {
    startHereModules: [{
      name: '',
      resources: [{
          type: 'download',
          image: { base: 'edex', path: '/resources/images/thumbnails/WhyDreamBox.png' },
          name: 'Why DreamBox?',
          description: '',
          links: [{
            url: { base: 'edex', path: '/resources/docs/resources/Why-Use-DreamBox-in-Your-Class.pdf' },
            type: 'pdf',
            language: 'English'
          }],
          newUntil: '2019-11-01T00:00:00'
        }, {
          type: 'download',
          image: { base: 'edex', path: '/resources/images/thumbnails/GettingStarted.png' },
          name: 'Getting started checklist',
          description: '',
          links: [{
            url: { base: 'edex', path: '/resources/docs/resources/BTS-Checklist-2020.pdf' },
            type: 'pdf',
            language: 'English'
          }],
          newUntil: '2019-11-01T00:00:00'
        }
      ]}
    ],

    classroomTabData: {
      sectionId: "edx-resources-intheclassroom",

      name: 'student-classes',

      header: 'DreamBox in Your Classroom',

      message: "We know how hard you work to engage, encourage, and teach your students every day. Learn how you can incorporate DreamBox into your weekly routine to maximize the impact of your math program without adding additional work to your already busy day!",

      whatsIncluded: [
        'Getting students started and ongoing best practices',
        'Ideas for using DreamBox in your classroom',
        'Information about our innovative K-8 digital curriculum'
      ],

      relatedArticles: [
        {
          url: 'https://support.dreambox.com/s/article/How-Students-Log-In-to-DreamBox-on-a-Computer-School-Account',
          title: 'How Students Log In to DreamBox on a Computer',
          analyticsLabel: 'How Students Log In to DreamBox on a Computer'
        }, {
          url: 'https://support.dreambox.com/s/article/How-Students-Log-In-to-DreamBox-on-an-iPad-School-Account',
          title: 'How Students Log In to DreamBox on an iPad',
          analyticsLabel: 'How Students Log In to DreamBox on an iPad'
        }, {
          url: 'https://support.dreambox.com/s/article/How-Students-View-Their-Weekly-Lessons-Completed',
          title: 'How Students View Their Weekly Lessons Completed',
          analyticsLabel: 'How Students View Their Weekly Lessons Completed'
        }, {
          url: 'https://support.dreambox.com/s/article/Initial-Placement-and-Assessment',
          title: 'Initial Placement and Assessment',
          analyticsLabel: 'Initial Placement and Assessment'
        }, {
          url: 'https://support.dreambox.com/s/article/How-Students-Progress-in-DreamBox',
          title: 'How Students Progress in DreamBox',
          analyticsLabel: 'How Students Progress in DreamBox'
        }
      ],

      modules: [
        {
          name: 'Student Learning Environments',
          resources: [{
            type: 'video',
            wistiaId: 'wistia_async_6yks15vlie',
            name: 'Adventure Park (K-2)'
          }, {
            type: 'video',
            wistiaId: 'wistia_async_4pu7igyols',
            name: 'Paper Frenzy (3-5)'
          }, {
            type: 'video',
            wistiaId: 'wistia_async_22rbhz3g21',
            name: 'Cool Frost (6-8)'
          }]

        }, {
          name: 'DreamBox in your Classroom',
          resources: [{
            type: 'download',
            image: { base: 'dashboard', path: '/introducing-dreambox-to-your-students-02.png' },
            name: 'Introducing DreamBox to Your Students',
            links: [{
              url: { base: 'dashboard', path: '/introducing-dreambox-to-your-students.pdf' },
              type: 'pdf',
              language: 'English'
            }]
          },
            {
              type: 'download',
              image: { base: 'dashboard', path: '/using-dreambox-in-your-classroom-02.png' },
              name: 'Using DreamBox in Your Classroom',
              links: [{
                url: { base: 'dashboard', path: '/using-dreambox-in-your-classroom.pdf' },
                type: 'pdf',
                language: 'English'
              }]
            }, {
              type: 'video',
              wistiaId: 'wistia_async_wxpcf6zw9k',
              name: 'Use DreamBox Learning to Automatically Differentiate Instruction'
            }, {
              type: 'video',
              wistiaId: 'wistia_async_nvanmo4ddk',
              name: 'Use DreamBox Learning in Your Computer Lab Rotation',
              htmlName: 'Use DreamBox Learning in Your Computer Lab&nbsp;Rotation'
            }, {
              type: 'video',
              wistiaId: 'wistia_async_s0hoqfsf3f',
              name: 'Use DreamBox Learning as Part of Your Station Rotation',
              htmlName: 'Use DreamBox Learning as Part of Your Station&nbsp;Rotation'
            }, {
              type: 'video',
              wistiaId: 'wistia_async_t2garl4n8h',
              name: 'The Science and Design Behind Our Curriculum',
            }, {
              type: 'video',
              wistiaId: 'wistia_async_sj31cx76q1',
              name: 'Acquiring an Appetite For Math: Motivating Students',
            }]
        }, {
          name: 'Product Release Innovations',
          resources: [{
            type: 'download',
            image: { base: 'dashboard', path: '/whats-new-with-dreambox-learning.png' },
            name: "Discover What's New with DreamBox Learning Math",
            links: [{
              url: { base: 'dashboard', path: '/Whats-New-With-DreamBox-Learning-Fall-SS-2018-09.pdf' },
              type: 'pdf',
              language: 'English'
            }]
          }]
        }
      ],

      analyticsCategory: 'Resources - Classroom'
    },

    parentsTabData: {
      sectionId: "edx-resources-parentfamily",

      name: 'parent-family',

      header: 'Parents &amp; Family',

      message: "Build a strong home connection with your students' families. View information and access tools to help you work closely with family learning guardians for student success.",

      whatsIncluded: [
        'Getting parents started',
        'Best practices for communicating with parents about DreamBox',
        'Monitoring progress and supporting learning at home'
      ],

      relatedArticles: [
        {
          url: 'https://support.dreambox.com/s/article/Understanding-the-Family-Insight-Dashboard',
          title: 'Understanding the Family Dashboard',
          analyticsLabel: 'Understanding the Family Dashboard'
        }, {
          url: 'https://support.dreambox.com/s/article/Set-Up-Parent-Access-on-a-School-Account',
          title: 'Set Up Parent Access on a School Account',
          analyticsLabel: 'Set Up Parent Access on a School Account'
        }, {
          url: 'https://support.dreambox.com/s/article/How-to-View-the-School-DreamBox-URL-Login-Code-and-Print-the-Parent-Invitation-Letter',
          title: 'How to View the School DreamBox URL/Login Code and Print the Parent Invitation Letter',
          analyticsLabel: 'How to View the School DreamBox URL/Login Code and Print the Parent Invitation Letter'
        }, {
          url: 'https://support.dreambox.com/s/article/How-to-Log-In-to-your-DreamBox-Family-Dashboard',
          title: 'How to Log In to your DreamBox Family Dashboard',
          analyticsLabel: 'How to Log In to your DreamBox Family Dashboard'
        }
      ],

      modules: [{
        name: 'Getting Started',
        resources: [{
          type: 'video',
          wistiaId: 'wistia_async_n30ovopr3w',
          name: 'Finding the Parent Letter'
        }, {
          type: 'video',
          wistiaId: 'wistia_async_shyeikkp74',
          name: 'Finding the Parent Letter for Single Sign-On (SSO)'
        }]
      }, {
        name: 'Tools to Support Parents and Families',
        resources: [{
          type: 'video',
          wistiaId: 'wistia_async_0wt8jhffwo',
          name: 'How to Setup Parent Access'
        }, {
          type: 'video',
          wistiaId: 'wistia_async_en316baksw',
          name: 'How to Setup Parent Access for Current Users'
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/DreamBox-Family-Math-Night.png' },
          name: 'Family Math Night Kit',
          links: [{
            url: { base: 'dashboard', path: '/Family-Math-Night-Kit-PI-2018-09.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/Family-Math-Night-Kit-Spanish-PI-2018-09.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/using-dreambox-at-home.png' },
          name: 'Using DreamBox Learning Math at Home',
          links: [{
            url: { base: 'dashboard', path: '/Using-DreamBox-At-Home-PI-2018-08.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/Using-DreamBox-at-Home-Spanish-PI-2018-09.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }]

      }],

      analyticsCategory: 'Resources - Family'
    },

    dashboardTabData: {
      sectionId: 'edx-resources-dashboardoverview',

      name: 'dashboard-overview',

      header: 'Dashboard Overview',

      message: "There's lots to learn about your students in your Insight Dashboard! Explore information and best practices for using real-time student data in your Dashboard to inform instruction and easily differentiate lessons.",

      whatsIncluded: [
        'Navigating your Dashboard',
        'Understanding your student and classroom reports',
        'Creating assignments with Assignments',
        'Classroom settings and management'
      ],

      relatedArticles: [
        {
          url: 'https://support.dreambox.com/s/article/Insight-Dashboard-Overview',
          title: 'Insight Dashboard Overview',
          analyticsLabel: 'Insight Dashboard Overview'
        }, {
          url: 'https://support.dreambox.com/s/article/Edit-Student-Details-Names-Username-Grade-Level-Passwords-Language',
          title: 'Edit Student Details (Names, Usernames, Grade Levels, Passwords, Language)',
          analyticsLabel: 'Edit Student Details (Names, Usernames, Grade Levels, Passwords, Language)'
        }, {
          url: 'https://support.dreambox.com/s/article/How-Do-I-Change-My-Student-s-Grade-Level',
          title: "How Do I Change My Student's Grade Level?",
          analyticsLabel: "How Do I Change My Student's Grade Level?"
        }, {
          url: 'https://support.dreambox.com/s/article/How-Can-I-See-If-a-Student-Is-Struggling',
          title: 'How can I See if a Student is Struggling?',
          analyticsLabel: 'How can I See if a Student is Struggling?'
        }, {
          url: 'https://support.dreambox.com/s/article/Insight-Dashboard-Reporting---Classroom-Level-Reports',
          title: 'Insight Dashboard Reporting - Classroom Level Reports',
          analyticsLabel: 'Insight Dashboard Reporting - Classroom Level Reports'
        }, {
          url: 'https://support.dreambox.com/s/article/Insight-Dashboard-Reporting---Student-Level-Reports',
          title: 'Insight Dashboard Reporting - Student Level Reports',
          analyticsLabel: 'Insight Dashboard Reporting - Student Level Reports'
        }, {
          url: 'https://support.dreambox.com/s/article/AssignFocus-How-to-Create-Assignments-School-Teachers-and-Administrators',
          title: 'Assignments - How to Create Assignments',
          analyticsLabel: 'Assignments - How to Create Assignments'
        }
      ],

      modules: [{
        name: 'Dashboard for Teachers',
        resources: [{
          type: 'download',
          image: { base: 'dashboard', path: '/DreamBox-Insight-Dashboard-Overview.png' },
          name: 'Insight Dashboard Overview',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-insight-dashboard-overview.pdf' },
            type: 'pdf',
            language: 'English'
          }]
        }, {
          type: 'video',
          wistiaId: 'wistia_async_5hrk1yovye',
          name: 'Dashboard Overview'
        }, {
          type: 'video',
          wistiaId: 'wistia_async_x2zjxhro6s',
          name: 'Finding Student Login Information'
        },
          {
            type: 'video',
            wistiaId: 'wistia_async_c4061wfllk',
            name: 'Finding Student Passwords'
          }, {
            type: 'video',
            wistiaId: 'wistia_async_ghcw2pmptn',
            name: 'Initial Placement and Setting Curricular Grade Level',
            htmlName: 'Initial Placement &amp; Setting Curricular Grade Level'
          }]
      }, {
        name: 'Assignments',
        resources: [{
          type: 'video',
          wistiaId: 'wistia_async_0wn7a6scd7',
          name: 'Assignments Overview'
        }, {
          type: 'video',
          wistiaId: 'wistia_async_0769g2vrme',
          name: 'Long Term Assignments'
        }, {
          type: 'video',
          wistiaId: 'wistia_async_nshtcq1sek',
          name: 'Short Term Assignments'
        }]
      }],

      analyticsCategory: 'Resources - Dashboard'
    },

    motivatorsTabData: {
      sectionId: 'edx-resources-motivators',

      name: 'motivators',

      header: 'Classroom Motivators',

      message: 'Enjoy these fun classroom materials to help you motivate and delight students to drive their learning!',

      whatsIncluded: [
        'Student certificates to celebrate successes',
        'Math journals and activities',
        'Motivational posters and calendars'
      ],

      relatedArticles: null,

      modules: [{
        name: 'Calendars',
        resources: [{
          type: 'download',
          image: { base: 'dashboard', path: '/blank-calendar-.png' },
          name: 'Blank Calendar',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-blank-calendar-03-18-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/grade-k-2-calendar.png' },
          name: 'Grades K-2: Track Progress',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-calendar-track-classroom-progress-grades-k-2-english-10-03-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-calendar-track-classroom-progress-grades-k-2-spanish-10-03-2016.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/grade-6-8-calendar.png' },
          name: 'Grades 3-5: Track Progress',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-calendar-track-classroom-progress-grades-3-5-english-10-03-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-calendar-track-classroom-progress-grades-3-5-spanish-10-03-2016.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/classroom-track-progress.png' },
          name: 'Grades 6-8: Track Progress',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-calendar-track-classroom-progress-grades-6-8-english-09-22-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-calendar-track-classroom-progress-grades-6-8-spanish-09-27-2016.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/school-track-progress.png' },
          name: 'School: Track Progress',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-calendar-track-school-progress-grades-english-09-22-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }]
        }]
      }, {
        name: 'Certificates',
        resources: [{
          type: 'download',
          image: { base: 'dashboard', path: '/Classroom-Motivators-K-2-Certificate-Thumbnail.jpg' },
          name: 'Grades K-2 Certificate',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-certificate-student-of-excellence-grades-k-2-english-03-01-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-certificate-student-of-excellence-grades-k-2-spanish-08-02-2016.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/6-8-certificate-thumbnail.png' },
          name: 'Grades 3-5 Certificate',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-certificate-student-of-excellence-grades-3-5-english-02-23-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/certificate-student-of-excellence-grades-3-5-spanish.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/6-8-certificate-thumbnail.png' },
          name: 'Grades 6-8 Certificate',
          links: [{
            url: { base: 'dashboard', path: '/certificate_student_excellence_6-8.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-loyalty-certificate-student-of-excellence-grades-6-8-spanish-07-28-2016.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }]
      }, {
        name: 'Elementary Activities',
        resources: [{
          type: 'download',
          image: { base: 'dashboard', path: '/how-to-draw-characters.png' },
          name: 'Drawing DreamBox Characters',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-how-to-draw-dreambox-characters-english-08-02-2016.zip' },
            type: 'zip',
            language: 'English'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/coloring-pages-thumbnail.png' },
          name: 'Coloring Pages',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-coloring-pages.zip' },
            type: 'zip',
            language: 'English'
          }]
        }]
      }, {
        name: 'Math Journals',
        resources: [{
          type: 'download',
          image: { base: 'dashboard', path: '/k-1-journal-.png' },
          name: 'Grades K-1 Math Journal',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-math-journal-grades-k-1-english-08-11-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-math-journal-grades-k-1-spanish-07-07-2016.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/2-3-journal-.png' },
          name: 'Grades 2-3 Math Journal',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-math-journal-grades-2-3-english-12-19-2013.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-math-journal-grades-2-3-spanish-07-07-2016.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/4-5-journal-.png' },
          name: 'Grades 4-5 Math Journal',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-math-journal-grades-4-5-english-12-19-2013.pdf' },
            type: 'pdf',
            language: 'English'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/6-8-journal-.png' },
          name: 'Grades 6-8 Math Journal',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-math-journal-grades-6-8-english-03-05-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/2017-Summer-Math-Journal-255x160.png' },
          name: 'Summer Math Journal',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-summer-math-journal-english-05-12-17.pdf' },
            type: 'pdf',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-summer-math-journal-spanish-05-12-17.pdf' },
            type: 'pdf',
            language: 'Spanish'
          }]
        }]
      }, {
        name: 'Posters & Tracking Progress',
        resources: [{
          type: 'download',
          image: { base: 'dashboard', path: '/posters-math-strategies-.png' },
          name: 'Posters: Math Strategies (Size: 8.5 x 11)',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-8.5x11-poster-math-strategies-english-08-02-2016.zip' },
            type: 'zip',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-8.5x11-poster-math-strategies-spanish-08-02-2016.zip' },
            type: 'zip',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/posters-jumper-.png' },
          name: 'Posters: Math Strategies (Size: 11 x 17)',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-11x17-poster-math-strategies-english-08-02-2016.zip' },
            type: 'zip',
            language: 'English'
          }, {
            url: { base: 'dashboard', path: '/dreambox-11x17-poster-math-strategies-spanish-08-02-2016.zip' },
            type: 'zip',
            language: 'Spanish'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/adventure-friend-checklist.png' },
          name: 'Adventure Friend Checklist',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-adventure-friend-checklist-english-12-18-2013.pdf' },
            type: 'pdf',
            language: 'English'
          }]
        }, {
          type: 'download',
          image: { base: 'dashboard', path: '/badge-.png' },
          name: 'Badge List',
          links: [{
            url: { base: 'dashboard', path: '/dreambox-badge-list-english-03-07-2016.pdf' },
            type: 'pdf',
            language: 'English'
          }]
        }]
      }],
      analyticsCategory: 'Resources - Dashboard'
    },

    // This is not used anywhere, but left here to avoid losing data
    teacherToolModules: [
    {
      name: 'Kindergarten Number Sense and Equivalence',
      resources: [{
        type: 'tool',
        image: { base: 'dashboard', path: '/teacher-tool.png' },
        name: 'Numbers to Ten on the TenFrame',
        description: 'Using a two by five array, the TenFrame supports the use of five as an anchor for early number sense.',
        lessonplan: 'http://www-static.dreambox.com/wp-content/uploads/lessons/K_Numbers%20to%20Ten%20on%20the%20TenFrame.pdf',
        links: [{
          url: { base: 'external', path: 'https://play.dreambox.com/student/remote_callout?try_a_lesson=TeacherLessonQuickImagesTenframe4to10&back=%2Fteachertools&eng=Primary&lcid=1033' },
          type: 'pdf',
          language: 'English'
        }, {
          url: { base: 'external', path: 'https://play.dreambox.com/student/remote_callout?try_a_lesson=TeacherLessonQuickImagesTenframe4to10&back=%2Fteachertools&eng=Primary&lcid=21514' },
          type: 'pdf',
          language: 'Spanish'
        }]
      }, {
        type: 'tool',
        image: { base: 'dashboard', path: '/teacher-tool.png' },
        name: 'Numbers to Ten on the MathRack',
        description: 'Using one, two, or ten wires, the MathRack supports the use of fives, tens, and doubles as anchors for supporting automaticity of',
        lessonplan: 'http://www-static.dreambox.com/wp-content/uploads/lessons/K_Numbers%20to%20Ten%20on%20the%20MathRack.pdf',
        links: [{
          url: { base: 'external', path: 'https://play.dreambox.com/student/remote_callout?try_a_lesson=TeacherLessonQuickImagesMathrack4to10&back=%2Fteachertools&eng=Primary&lcid=1033' },
          type: 'pdf',
          language: 'English'
        }, {
          url: { base: 'external', path: 'https://play.dreambox.com/student/remote_callout?try_a_lesson=TeacherLessonQuickImagesMathrack4to10&back=%2Fteachertools&eng=Primary&lcid=21514' },
          type: 'pdf',
          language: 'Spanish'
        }]
      }, {
        type: 'tool',
        image: { base: 'dashboard', path: '/teacher-tool.png' },
        name: 'Numbers to Twenty on the MathRack',
        description: 'Using a two by five array, the TenFrame supports the use of five as an anchor for early number sense.',
        lessonplan: 'http://www-static.dreambox.com/wp-content/uploads/lessons/K_Numbers%20to%20Ten%20on%20the%20TenFrame.pdf',
        links: [{
          url: { base: 'external', path: 'https://play.dreambox.com/student/remote_callout?try_a_lesson=TeacherLessonQuickImagesTenframe11to20&back=%2Fteachertools&eng=Primary&lcid=1033' },
          type: 'pdf',
          language: 'English'
        }, {
          url: { base: 'external', path: 'https://play.dreambox.com/student/remote_callout?try_a_lesson=TeacherLessonQuickImagesTenframe11to20&back=%2Fteachertools&eng=Primary&lcid=21514' },
          type: 'pdf',
          language: 'Spanish'
        }]
      }]
    }]
  });
